module.exports = __webpack_public_path__ + "static/media/elevator.8acf63e4.svg";